/**
 * PageTitle Component
 * Standard page title with consistent margin bottom
 */

import React from 'react';
import { Typography } from '@mui/material';
import { PAGE_BODY } from '../../theme';

const PageTitle = ({ children, variant = 'h5', sx = {}, ...props }) => {
  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight: 600,
        mb: `${PAGE_BODY.margins.titleBottom}px`,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default PageTitle;
